import React from 'react';
import Administrators from './components/Administrators';
import NotificationSettings from './components/NotificationSettings';
import styles from './Settings.module.css';
import ListGrid from '../../common/components/ListGrid/ListGrid';
import {renderNavigation, renderRouting} from '../../utils/routing';
import {Permit, Role} from "../../components/SessionInfo";



export default function Settings({ sessionInfo }) {
    const routes = {
        '/settings/administrators': {
            label: 'Учетные записи',
            renderContent: () => <Administrators permission={Permit.write(Role.ADMIN).read(Role.ADMIN_INFORMATION_SECURITY).get(sessionInfo.role)}/>,
            isDefault: true,
        },
        '/settings/notifications': {
            label: 'Уведомления',
            renderContent: () => <NotificationSettings permission={Permit.write(Role.ADMIN).read(Role.ADMIN_INFORMATION_SECURITY).get(sessionInfo.role)} sessionInfo={sessionInfo}/>,
            isDefault: true,
        }
    };  return (
    <ListGrid
      header={(
        <div className={styles.navigation}>
          {renderNavigation({routes, styles})}
        </div>
      )}
      body={renderRouting({routes})}
    />
  );
}
